<ng-template #template1>
    <div class="d-flex flex-column">
        <span>Market Value (MV) and Taxable Value (TV) are now available in Parcel Annual Details.</span>
        <br>
        <div class="d-flex">
            <div class="number-dot">1</div>
            <span>Market Value (MV) (replaces FMV) now shows the value before additional components (e.g. Exemption) and
                alternate assessments are applied.</span>
        </div>
        <br>
        <div class="d-flex">
            <div class="number-dot">2</div>
            <span>Taxable Value (TV) now shows the value after additional components and alternate assessments are
                applied and is used to calculate taxes.</span>
        </div>
    </div>
    <div class="d-flex align-items-center justify-content-center">
        <img src="/images/onboarding/4.png"
             style="max-width: 585px;"
             alt="slide"
             class="carousel-image w-100">
    </div>
</ng-template>

<ng-template #template2>
    <div class="d-flex">
        <div class="number-dot">1</div>
        <span>In some jurisdictions, a parcel may have more than one taxable value due to how the Tax Rate Authority
            is configured at the parcel level and how taxable values are calculated for individual taxing
            entities.</span>
    </div>
    <div class="d-flex align-items-center justify-content-center">
        <img src="/images/onboarding/5.png"
             style="max-width: 650px;"
             alt="slide"
             class="carousel-image w-100">
    </div>
</ng-template>

<ng-template #template3>
    <div class="d-flex flex-column">
        <span>This enhancement supports more precise tax calculations, especially in jurisdictions where taxes may be
            assessed on more than one taxable value—giving you better insight and flexibility.</span>
        <br>
        <ul>
            <li>
                <span>Effective Rate – the percentage of a property's total market value paid in taxes annually.</span>
            </li>
            <li>
                <span>Base Rate – actual rate that is applied to a parcel’s taxable value(s), excluding any direct
                    assessments, discount, interest or penalty. *</span>
            </li>
        </ul>
    </div>
    <div class="d-flex align-items-center justify-content-center">
        <img src="/images/onboarding/6.svg"
             style="max-width: 250px;"
             alt="slide"
             class="carousel-image w-100">
    </div>
    <span>* When a parcel has multiple taxable values, the Base Rate is calculated by weighting each value according to
        its proportion of the total.</span>
</ng-template>

<ng-template #template4>
    <div class="d-flex flex-column">
        <span>To support analysis and decision-making, MV and TV can now be pulled into <b>SMARTs, Action Views,
            Reports, Forecasting & Budgeting</b> to support analysis and decision-making.</span>
        <br>
        <span class="mb-2">Want the details? Check out this <a target="_blank" href="https://softwaresupport.ryan.com/hc/en-us/articles/48853463444115-New-Enhancement-Market-Value-Taxable-Value">Help Desk article</a> to learn more about this
            enhancement.</span>
    </div>
</ng-template>

<ws-modal-wrapper [headerLabel]="title"
                  cancelLabel="CLOSE"
                  [hideCancel]="currentSlide === slides.length - 1"
                  [acceptLabel]="progressBtnLabel"
                  bodyClass="pb-0"
                  [useAceStyles]="true"
                  [ignoreCloseOnRoute]="true"
                  (save)="progress()"
                  (cancel)="cancel($event)">
    <ws-carousel [slides]="slides"
                 [(currentSlide)]="currentSlide"
                 [imgHeight]="800"
                 [imgWidth]="600"
                 [disableControls]="true">
    </ws-carousel>
</ws-modal-wrapper>
